import { Grid } from '@material-ui/core';
import React from 'react';
import './ExpandingGrid.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ErrorIcon from '@material-ui/icons/Error';
import { useLang } from '../../../util/lang';

const ExpandingGrid = ({
    questionId,
    title,
    children,
    expandable = false,
    openExpand,
    isRequired = false,
    isError = false,
    isAnswered = false,
    showErrorBorder = false,
}) => {
    const getLang = useLang('NewPatient');

    // 点击可展开区域时打开详情弹窗
    const handleExpandBtnOnClick = () => {
        if (!expandable) return;
        if (!openExpand || typeof openExpand !== 'function')
            throw new Error('openExpand function is required for expandable ExpandingGrid component');
        openExpand();
    };

    const isUnanswered = isRequired && !isAnswered && !isError;
    const showAnswered = isAnswered && !isError && !isUnanswered;
    const className = `expanding-grid-children${expandable ? '-btn' : ''}${showAnswered ? ' answered' : ''}${isUnanswered ? ' unanswered' : ''}${showErrorBorder ? ' error-border' : ''}`;

    return (
        <Grid container style={{ display: 'flex', width: '100%', alignItems: 'center', marginBottom: 12 }}>
            <Grid item xs={4}>
                <li id={questionId} className={'field_label'} {...(isRequired ? { 'data-mandatory': true } : {})}>
                    {title}
                </li>
            </Grid>
            <Grid
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    fontWeight: 400,
                }}
                className={className}
                onClick={handleExpandBtnOnClick}
                item
                xs={7}
            >   
                {(showErrorBorder || isUnanswered) ? <div>{getLang('prescriptionNotes.archToTreatPlaceholder')}</div> : children}
                <span>
                    {isError && <ErrorIcon style={{ color: 'red' }} />}
                    {expandable && <ExpandMoreIcon />}
                </span>
            </Grid>
        </Grid>
    );
};

export default ExpandingGrid;
